<script>
    import { fade } from 'svelte/transition';
    import {link , push } from 'svelte-spa-router'
    import UserStore from '../../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../../components/Header.svelte'; 
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte'; 
    import Token from '../../components/Token.svelte'; 

    let isLoading = false;

    onMount(async() => {

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }
    })


    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment">
            <Token />
            <div class="platforms-list gap-3 flex flex-col">
                <a class="" href="#/docs/wordpress">
                    <span>
                        <img src="{siteUrl}images/docs/wordpress.svg">
                    </span>
                    <span>
                        {$_('docs.wordpress_title')}
                    </span>
                </a>
                <a class="" href="#/docs/shopify">
                    <span>
                        <img src="{siteUrl}images/docs/shopify.svg">
                    </span>
                    <span>
                        {$_('docs.shopify_title')}
                    </span>
                </a>
                <a class="" href="#/docs/wix">
                    <span>
                        <img src="{siteUrl}images/docs/wix.svg">
                    </span>
                    <span>
                        {$_('docs.wix_title')}
                    </span>
                </a>
                <a class="" href="#/docs/konimbo">
                    <span>
                        <img src="{siteUrl}images/docs/konimbo.jpg">
                    </span>
                    <span>
                        {$_('docs.konimbo_title')}
                    </span>
                </a>
                <a class="" href="#/docs/rest">
                    <span>
                        <img src="{siteUrl}images/docs/api.svg">
                    </span>
                    <span>
                        {$_('docs.rest_api_title')}
                    </span>
                </a>
            </div>

        </div>
    </div>
</div>
<style>
.platforms-list img{
    width: 50px;;    
}
</style>
